export class IsMusicStartStorage {
    public static isCanStart: boolean = false;
}